import { render, staticRenderFns } from "./ModalRegistration.vue?vue&type=template&id=63c95024&"
import script from "./ModalRegistration.vue?vue&type=script&lang=ts&"
export * from "./ModalRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports